import { Component, Inject, OnInit, Optional, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ToastrService } from 'ngx-toastr';
import { ConfirmDialogComponent } from 'src/app/material-module/confirm-dialog/confirm-dialog.component';
import { Ramo } from 'src/app/models/ramo';
import { RamoService } from 'src/app/services/ramo.service';
import { dataTableColumnDefinition } from 'src/app/shared/resourceful-index/dataTableColumnDefinition';
import { ResourcefulIndexComponent } from 'src/app/shared/resourceful-index/resourceful-index/resourceful-index.component';
import { RamiFormComponent } from './dialogs/form/form.component';

@Component({
  selector: 'rami',
  templateUrl: './rami.component.html',
  styleUrls: ['./rami.component.scss']
})
export class RamiComponent implements OnInit {


  headingText: string = 'Rami';

  relations: string[] = ['gruppo_rami'];

  @ViewChild('index') index: ResourcefulIndexComponent;

  selectionMode: boolean = false;

  loading: boolean = true;

  search: any;

  columnDefinitions: dataTableColumnDefinition[] = [
    new dataTableColumnDefinition(
      {
        humanName: 'ID',
        internalName: 'id',

      }
    ),
    new dataTableColumnDefinition(
      {
        humanName: 'Nome',
        internalName: 'nome',

      }
    ),
    new dataTableColumnDefinition(
      {
        humanName: 'Gruppo rami',
        internalName: 'gruppo_rami',
        sortDisabled: true,
        displayFunction: (model) => model?.gruppo_rami?.humanIdentifier,
      }
    ),

  ];
  constructor(public ramoService: RamoService,
    public dialog: MatDialog,
    private toast: ToastrService,
    private fb: FormBuilder,
    @Optional() private dialogRef: MatDialogRef<RamiComponent>,
    @Optional() @Inject(MAT_DIALOG_DATA) public data,) {
    if (this.data?.selectionMode) {
      this.selectionMode = true;
      this.headingText = 'Seleziona un ramo';
    }
  }

  form: FormGroup;
  ngOnInit() {
    this.form = this.fb.group({
      nome: [],
    });

    this.form.valueChanges.subscribe(newValues => this.search = newValues);

  }

  async ngAfterViewInit(): Promise<void> {
    await this.updateDataSource();
    this.loading = false;
  }

  closeDialogWithSelectedModel(model) {
    this.dialogRef?.close(model);
  }

  async updateDataSource() {
    await this.index?.updateData();
  }


  deleteFunction = async (ramo: Ramo) => {
    try {
      let dialogRef = this.dialog.open(ConfirmDialogComponent, { data: { message: `Sei sicuro di voler eliminare il ramo ${ramo.nome}?` } });
      dialogRef.afterClosed().subscribe(async data => {
        if (data) {
          await this.ramoService.delete(ramo);
          this.toast.success('ramo eliminato.');
          this.updateDataSource();
        }
      });
    } catch (e) {
      console.error(e);
      this.toast.error("Eliminazione ramo fallita.", "Errore!");
    }
  }



  editFunction = async (ramo: Ramo) => {
    try {
      let dialogRef = this.dialog.open(RamiFormComponent, { data: ramo });
      dialogRef.afterClosed().subscribe(async (data: Ramo) => {
        if (data) {

          Object.assign(ramo, data);

          await this.ramoService.edit(ramo);

          this.toast.success('ramo modificato');
          this.updateDataSource();

        }
      });

    } catch (e) {
      console.error(e);
      this.toast.error("Modifica ramo fallita.", "Errore!");
    }
  }


  add() {
    let addDialogRef = this.dialog.open(RamiFormComponent, { data: this.search });
    addDialogRef.afterClosed().subscribe(data => this.handleCreation(data));
  }

  async handleCreation(ramo?: Ramo) {
    if (ramo) {
      try {
        await this.ramoService.create(ramo)
        this.toast.success('ramo creato!')
      }
      catch (e) {
        this.toast.error('Creazione ramo fallita.', 'Errore!');
      }
      finally {
        this.updateDataSource();
      }

    }
  }


}
